module.exports = __webpack_public_path__ + "static/media/sexy-dating-legs.76f9fb4d.png";